const BACKEND_MASTER_PREFIX = "Mestre";

export const isBackendMasterAddress = value => String(value).startsWith(BACKEND_MASTER_PREFIX);

export const formatDeviceAddress = (value, strings) =>
  String(value).replace(/^Mestre\b/, strings.MASTER_STRING);

export const matchesDeviceAddress = (value, query, strings) => {
  const normalizedQuery = String(query).trim().toLocaleLowerCase();
  const rawValue = String(value).toLocaleLowerCase();
  const displayedValue = formatDeviceAddress(value, strings).toLocaleLowerCase();

  return rawValue.startsWith(normalizedQuery) || displayedValue.startsWith(normalizedQuery);
};
